var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},_vm._l((_vm.tabList),function(item,index){return _c('div',{key:item.label,staticClass:"tab-title",class:{ active: _vm.currentIndex === index },on:{"click":function($event){return _vm.handleClick(item.value, index)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4395fd1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab/Tab.vue
// module id = null
// module chunks = 